/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshCardTabScheme} from '../api'

export const useMutationRefreshCardTabScheme = createReactQueryMutationHook('refreshCardTabScheme', refreshCardTabScheme)
